import { Box, Stack, Typography } from '@mui/material';
import { Icon } from '@aibees/shared/components';
import { classnames } from '@aibees/shared/utils';
import { useWhiteLabelContext } from '@aibees/elephant/feature/white-label/context';
import { memo } from 'react';
import * as Styled from './styles';
import * as SX from './sx';
import type { NotificationPreviewProps as Props } from './types';
import { hexToRgba } from './utils';

export const NotificationPreview = memo(({ className }: Props) => {
  const { primaryColor } = useWhiteLabelContext();

  const color = !primaryColor.error ? primaryColor.value : undefined;

  return (
    <Styled.Wrapper
      className={classnames('NotificationPreview', className)}
      title="Notification"
    >
      <Stack sx={SX.root} gap={1}>
        <Stack
          direction="row"
          justifyContent="flex-end"
          alignItems="center"
          gap={3}
          sx={SX.header(color)}
        >
          <Box sx={SX.iconWrapper}>
            <Icon name="bell" sxx={SX.bell(color)} size={18} />
            <Box sx={SX.count(color)}>23</Box>
          </Box>
          <Stack
            sx={SX.avatarWrapper(color)}
            justifyContent="center"
            alignItems="center"
          >
            <Icon name="person-outline" sxx={SX.avatar(color)} size={18} />
          </Stack>
        </Stack>
        <Stack sx={SX.notif(color)}>
          <Stack
            direction="row"
            alignItems="center"
            justifyContent="space-between"
            sx={SX.notifHeader(color)}
          >
            <Typography sx={SX.notifTitle(color)}>Notifications</Typography>
            <Icon name="close" size={18} />
          </Stack>
          <Stack
            sx={SX.container(hexToRgba(color, 0.1))}
            justifyContent="space-between"
            alignItems="center"
          >
            <Stack sx={SX.content(color)} gap={1.5}>
              <Stack direction="row" alignItems="center" gap={1}>
                <Box component="span" sx={SX.unread(false)} />
                <Typography sx={SX.title(color)}>List Updated!</Typography>
              </Stack>
              <Typography sx={SX.description(false)}>
                Your export from{' '}
                <Typography component="span" sx={SX.description(true)}>
                  similarity_company_export
                </Typography>
                is complete and has been emailed to you.
              </Typography>
              <Stack
                direction="row"
                alignItems="center"
                justifyContent="space-between"
              >
                <Box sx={SX.button(color)}>download </Box>
                <Typography sx={SX.date}>5 Seconds ago, 13:09</Typography>
              </Stack>
            </Stack>
            <Typography sx={SX.clear}>Clear notification</Typography>
          </Stack>
        </Stack>
      </Stack>
    </Styled.Wrapper>
  );
});

NotificationPreview.displayName = 'NotificationPreview';
